export default __webpack_public_path__ + "static/simple-doughnut-351ca6078199905103d044eee0820935.png";